export enum SortState {
	NONE,
	ASC,
	DESC
}
